import api from './axiosConfig';
const url = '/api/empresas';

export const obtenerEmpresas = async () => {
  try {
    const { data } = await api.get(`${url}/ver/empresas`);
    return data.empresas ?? [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const obtenerEmpresasKyrios = async () => {
  try {
    const { data } = await api.get(`${url}/ver/empresas/kyrios`);
    return data.empresas ?? [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const obtenerCentros = async (id_empresa) => {
  try {
    const { data } = await api.get(`${url}/ver/centros/${id_empresa}`);
    return data.centros ?? [];
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};